import styles from './Condiciones.module.css';

export const Condiciones = () => {
  return (
    <>
      <div className="row">
          <div className="col">
              <div className={styles.innerPanel}>
                  <p className={styles.subheader}>Términos y condiciones</p>
                  <p className={styles.text}>1. **Acceso y Uso del Expediente Electrónico**: El expediente electrónico especializado en alergias es una herramienta proporcionada por [Nombre de la Clínica/Empresa] para uso exclusivo de los pacientes y el personal autorizado. Al acceder o utilizar este sistema, aceptas cumplir con los siguientes términos y condiciones.</p>
                  <p className={styles.text}>2. **Confidencialidad de la Información**: Toda la información médica y personal almacenada en el expediente electrónico está sujeta a estrictas medidas de confidencialidad y protección de datos. El acceso a esta información está restringido al personal médico autorizado y al paciente, quien puede acceder a su propio expediente mediante credenciales seguras.</p>
                  <p className={styles.text}>3. **Responsabilidad del Usuario**: Los usuarios del expediente no debes acceder ni utilizar el sistema.</p>
              </div>
          </div>
      </div>
    </>
  )
}
